"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable */
// This was copied from https://bitbucket.cheggnet.com/projects/MT/repos/martech-adobe-mcid-generator/browse/generateRandomID.js
// Which was in turn in a duplication of adobe id logic
// I took out the argument because we aren't going to pass it.  For now not going to attempt to detangling this, since it came minified
// Basically just return a pseudorandom number
var generateLocalMcid = function generateLocalMcid() {
  var c = '0123456789',
      d = '',
      e = '',
      f,
      g,
      i = 10,
      j = 10;

  for (f = 0; 19 > f; f++) {
    g = Math.floor(Math.random() * i), d += c.substring(g, g + 1), 0 === f && 9 == g ? i = 3 : (1 == f || 2 == f) && 10 != i && 2 > g ? i = 10 : 2 < f && (i = 10), g = Math.floor(Math.random() * j), e += c.substring(g, g + 1), 0 === f && 9 == g ? j = 3 : (1 == f || 2 == f) && 10 != j && 2 > g ? j = 10 : 2 < f && (j = 10);
  }

  return d + e;
};

var _default = generateLocalMcid;
exports["default"] = _default;